<template>
	<div>
		<el-drawer :visible.sync="drawer" title="达人详情" size="1020px" :before-close="handleClose">
			<div class="detail-drawer" :class="{ business: isClaim && isLoginPartner }">
				<div class="detail-drawer-wrap">
					<div class="tips" v-if="isShowTips">
						<p class="fz-14">
							<i class="el-icon-warning mr-4 warning"></i>
							<span>{{ warnTitle }}</span>
							<span class="warning ml-8 pointer" @click="modifyFun">
								{{ warnTips }}
								<i class="el-icon-arrow-right pointer"></i>
							</span>
						</p>
					</div>
					<div class="top">
						<div class="left">
							<yx-avatar :size="68" :src="anchor_info.head" />
						</div>
						<div class="right">
							<div class="flex">
								<div class="ml-4 talent-info">
									<div class="flex flex-align-center">
										<platform-icon style="flex-shrink: 0" :platformId="anchor_info.platform_id" class="logo mr-4"></platform-icon>
										<el-tooltip placement="top" :content="anchor_info.anchor_name">
											<div class="font-bold ellipsis fz-18">{{ anchor_info.anchor_name }}</div>
										</el-tooltip>
										<level-tag v-if="$isDy(anchor_info.platform_id)" class="ml-4" :lv="anchor_info.anchor_level" />

										<IntroductionDialog
											v-if="showIntroduction"
											:isShowInfo="isShowInfo"
											:anchorId="anchor_info.id"
											:source="source"
											:anchor="anchor_info"
										/>
									</div>
									<div class="mt-4 fz-12 yx-color-text-regular nowrap">
										<span class="uid" v-if="$isKs(anchor_info.platform_id)">ID：{{ anchor_info.anchor_uid || '--' }}</span>
										<span v-if="$isPlatOr(anchor_info.platform_id, ['Dy', 'Ks'])">
											{{ anchor_info.platform_id | formatPlatformName('unify') }}：{{ anchor_info.anchor_account }}
										</span>
										<span v-if="$isSp(anchor_info.platform_id)">
											{{ anchor_info.platform_id | formatPlatformName('unify') }}：{{ anchor_info.anchor_uid }}
										</span>
									</div>
									<SpVerify
										@refresh="handleSpVerify"
										:anchoId="anchor_info.anchor_id"
										:anchorUid="anchor_info.anchor_uid"
										v-if="$isSp(anchor_info.platform_id)"
										:type="anchor_info.check_status"
									/>
									<div class="mt-4">
										<div class="fans">粉丝数：{{ anchor_info.fans_num }}</div>
										<div class="ml-4 auth" :class="{ ks: $isKs(anchor_info.platform_id) }" v-if="anchor_info.anchor_auth_status">
											{{ anchor_info.platform_id | formatPlatformName }}授权
										</div>
									</div>
									<div class="mt-8 flex-row flex-just-between" v-if="isClaim">
										<template v-if="$isDy(anchor_info.platform_id)">
											<div>
												<div class="fz-16 yx-pingfang-semibold">
													{{ anchor_info.month_sale }}
												</div>
												<div class="fz-12 yx-color-info flex-row">
													月橱窗销量
													<Explain content="授权达人可获取近30日橱窗销量"></Explain>
												</div>
											</div>
											<div>
												<div class="fz-16 yx-pingfang-semibold">
													{{ anchor_info.month_live_sale }}
												</div>
												<div class="fz-12 yx-color-info flex-row">
													月橱窗销售额
													<Explain content="授权达人可获取近30日橱窗销售额"></Explain>
												</div>
											</div>
										</template>
										<template v-if="$isKs(anchor_info.platform_id)">
											<div>
												<div class="fz-16 yx-pingfang-semibold">
													{{ anchor_info.month_sale }}
												</div>
												<div class="fz-12 yx-color-info flex-row">
													月订单量
													<Explain content="授权达人可获取近30日订单量"></Explain>
												</div>
											</div>
											<div>
												<div class="fz-16 yx-pingfang-semibold">
													{{ anchor_info.month_live_sale }}
												</div>
												<div class="fz-12 yx-color-info flex-row">
													月销售额
													<Explain content="优先展示系统自动获取的数据，若未获取则展示您所填信息"></Explain>
												</div>
											</div>
											<div>
												<div class="fz-16 yx-pingfang-semibold">
													{{ anchor_info.live_sale }}
												</div>
												<div class="fz-12 yx-color-info flex-row">
													场均销售额
													<Explain content="优先展示系统自动获取的数据，若未获取则展示您所填信息"></Explain>
												</div>
											</div>
										</template>
									</div>
									<div class="flex-row-align-center font-h6-regular mt-8">
										<div class="yx-color-info nowrap mr-12">达人标签：</div>
										<rd-text>{{ tagName | formatEmpty }}</rd-text>
									</div>
								</div>
								<div class="line"></div>
								<div class="fz-12 flex-1">
									<div class="flex flex-align-center flex-just-between">
										<div class="flex">
											<div class="yx-color-info nowrap mr-12" v-if="$isPlatOr(anchor_info.platform_id, ['Dy', 'Ks'])">类目：</div>
											<div class="yx-color-info nowrap mr-12" v-if="$isSp(anchor_info.platform_id)">账号分类：</div>
											<div class="yx-color-text-regular" v-if="!recommendType.length">-</div>
											<div v-else class="flex">
												<div class="recommend-item" v-for="(item, index) in recommendType" :key="index">{{ item }}</div>
											</div>
										</div>

										<div class="pos-abso flex-row-align-center" style="right: 70px" v-if="$isDy(anchor_info.platform_id)">
											<div
												class="yx-background flex-row-align-center i-talentCRM-myTalentDetail-starCard-dy color-gy-8 cursor-pointer"
												@click="handleGoDy"
												v-if="anchor_info.jx_main_url"
											>
												<i class="i-magic-dy-icon" />
												<span>达人详情</span>
												<i style="font-size: 10px" class="el-icon-arrow-right" />
											</div>
										</div>
										<div
											v-if="$isKs(anchor_info.platform_id)"
											class="handleGoKs pos-abso flex-row-align-center cursor-pointer"
											style="right: 70px"
											@click="handleGoKs"
										>
											<platform-icon class="mr-2" style="flex-shrink: 0" :platformId="anchor_info.platform_id" />
											<span>官方详情</span>
											<i class="iconfont icon-a-rightxiangyoujiantou right-icon yx-color-g-8" style="zoom: 0.8"></i>
										</div>
										<el-popover v-if="$isDy(anchor_info.platform_id)" placement="bottom-end" trigger="hover">
											<div class="popover-qr">
												<el-image :src="hostUrl + anchor_info.main_qr">
													<template v-slot:placeholder>
														<img src="@/assets/public/img-empty.png" alt="" />
													</template>
													<template v-slot:error>
														<img src="@/assets/public/img-empty.png" alt="" />
													</template>
												</el-image>
												<div class="text">打开抖音APP，进入首页-搜索-扫一扫，扫描二维码查看达人主页</div>
											</div>
											<el-button slot="reference" size="mini"><span class="iconfont icon-31erweima mr-4"></span></el-button>
										</el-popover>
									</div>
									<div class="flex mt-6">
										<div class="yx-color-info nowrap mr-12">简介：</div>
										<el-tooltip placement="top" :content="anchorDesc">
											<div class="yx-color-text-regular line-clamp-3">{{ anchorDesc }}</div>
										</el-tooltip>
									</div>
								</div>
							</div>
							<div class="info" v-if="isClaim">
								<div>
									<span class="yx-color-info">跟进人：</span>
									{{ partnerInfo.partner_role_name }}
								</div>
								<div>
									<span class="yx-color-info">合作状态：</span>
									{{ partnerInfo.cooperate_status_name }}
								</div>
								<div>
									<span class="yx-color-info">最近跟进时间：</span>
									{{ partnerInfo.follow_time }}
								</div>
								<div class="handler" v-if="anchor_info.many_partner && partners.length > 1" @click="showFollowDialog">
									共{{ partners.length }}位跟进人>
								</div>
								<tooltip
									class="expire"
									v-if="!anchor_info.many_partner && partnerInfo.is_expire == '1'"
									label="跟进已到期"
									content="达人已满足自动流转回团队公海，其余商务可认领达人"
								></tooltip>
							</div>
							<div class="mt-20 align-right" v-if="isClaim">
								<span class="fz-12 yx-color-info mr-16">达人基础数据更新时间：{{ anchor_info.sync_base_real_time }}</span>
								<el-tooltip
									content="无快手id暂不支持手动更新数据"
									placement="top"
									:disabled="$isDy(anchor_info.platform_id) || !!anchor_info.anchor_uid || $isSp(anchor_info.platform_id)"
								>
									<span>
										<el-button
											size="mini"
											icon="el-icon-refresh"
											:disabled="$isKs(anchor_info.platform_id) && !anchor_info.anchor_uid"
											@click="syncAnchorBase"
										>
											手动更新
										</el-button>
									</span>
								</el-tooltip>
							</div>
						</div>
					</div>
					<div class="bg-line"></div>
					<div class="pl-12 pr-10">
						<el-tabs v-model="activeTab">
							<el-tab-pane label="合作数据" name="1">
								<cooperation-data-tab ref="cooperationDataTab" :partners="partners" :anchor-id="anchor_id" />
							</el-tab-pane>
							<el-tab-pane label="联系信息" name="2">
								<contact-data-tab
									ref="contactDataTab"
									:anchor-info="anchor_info"
									:anchor-id="anchor_id"
									:is-login-partner="isLoginPartner"
									@showBuildContactDialog="showBuildContactDialog"
									@showLinkmanDialog="showLinkmanDialog"
								/>
							</el-tab-pane>
							<el-tab-pane label="达人数据概览" name="3">
								<talent-data-tab
									ref="talentDataTab"
									:is-claim="isClaim"
									:anchor-uid="anchor_info.anchor_uid"
									:anchor-id="anchor_id"
									:platformId="anchor_info.platform_id"
									@handlerTab="handlerTab"
									:isShowGoods="isShowGoods"
								/>
							</el-tab-pane>
							<el-tab-pane label="带货商品" name="4" v-if="$isDy(anchor_info.platform_id) && isShowGoods">
								<goods-data-tab ref="goodsDataTab" :anchor-uid="anchor_info.anchor_uid" />
							</el-tab-pane>
						</el-tabs>
						<!-- <talent-data-tab v-else class="mt-24" ref="talentDataTab" :is-claim="isClaim" :anchor-uid="anchor_info.anchor_uid" @handlerTab="handlerTab" /> -->
					</div>
				</div>
				<div class="bottom-btn" v-if="isLoginPartner">
					<el-button type="primary" v-if="!showStatus(5) && $auth.hasPermi('system:talent:attention')" @click="setTalentFocus">
						{{ anchor_info.focus == 1 ? '重点' : '取消' }}关注
					</el-button>
					<el-button type="primary" v-if="!showStatus(5) && $auth.hasPermi('system:talent:master-failure')" @click="showInvalidDialog">
						转为失效
					</el-button>
					<el-button type="primary" v-if="showStatus(1) && $auth.hasPermi('system:talent:Construction')" @click="showBuildContactDialog">
						建联
					</el-button>
					<el-button type="primary" v-if="showStatus(2, 4) && $auth.hasPermi('system:talent:push-product')" @click="goToGoodsPage">推品</el-button>
					<el-button type="primary" v-if="showStatus(5) && $auth.hasPermi('system:tanlent:recover')" @click="activateTalent">恢复</el-button>
				</div>
			</div>
		</el-drawer>
		<invalid-dialog ref="invalidDialog" @getList="getList" />
		<build-contact-dialog ref="buildContactDialog" @getList="getList" />
		<linkman-dialog ref="linkmanDialog" @getList="getInfo" />
		<modifyDyId ref="modifyDyId" @refresh="refresh"></modifyDyId>
		<addDyHomeUrl ref="addDyHomeUrl" @refresh="refresh"></addDyHomeUrl>
		<addKsHomeUrl ref="addKsHomeUrl" @refresh="refresh"></addKsHomeUrl>
		<addJxHomeUrl ref="addJxHomeUrl" @refresh="refresh"></addJxHomeUrl>
		<follow-dialog ref="followDialog" />
	</div>
</template>

<script>
import { mapState } from 'vuex';
import talentDataTab from './components/talentDataTab';
import goodsDataTab from './components/goodsDataTab';
import cooperationDataTab from './components/cooperationDataTab';
import contactDataTab from './components/contactDataTab';
import invalidDialog from './components/invalidDialog';
import followDialog from './components/followDialog';
import buildContactDialog from '../buildContactDialog';
import linkmanDialog from '../linkmanDialog';
import tooltip from '../tooltip';
import throttle from 'lodash/throttle';
import { getAnchorDetail, effectTalent, setTalentFocus, syncAnchorBase, syncSphAnchorBase, getLiveProductList } from '@/api/talentCRM';
import addDyHomeUrl from '@/views/common/dialog/addDyHomeUrl';
import addKsHomeUrl from '@/views/common/dialog/addKsHomeUrl';
import modifyDyId from '@/views/common/dialog/modifyDyId';
import addJxHomeUrl from '@/views/common/dialog/addJxHomeUrl';
import Explain from '@/components/common/explain';
import { PLATFORM_OBJ } from '@/utils/dataMap';
// import drIntroduction from '@/components/business/drIntroduction';
import IntroductionDialog from '@/views/talentCRM/components/introductionDialog';
import { CLUE_SEAS, EMPHASIS_TALENT, MY_TALENT, GROUP_SEAS } from '@/utils/newDataMap/talentCRM';
import SpVerify from '@/components/business/SpVerify';
export default {
	name: 'detailDrawer',
	components: {
		talentDataTab,
		goodsDataTab,
		cooperationDataTab,
		contactDataTab,
		invalidDialog,
		buildContactDialog,
		linkmanDialog,
		modifyDyId,
		addDyHomeUrl,
		addKsHomeUrl,
		addJxHomeUrl,
		followDialog,
		tooltip,
		Explain,
		// drIntroduction,
		IntroductionDialog,
		SpVerify,
	},
	props: {
		isClueSeas: {
			type: Boolean,
			default: false,
		},
	},
	inject: {
		checkTalentCRMPermission: {
			default: () => {
				return {
					auth: false,
				};
			},
		},
	},
	data() {
		return {
			drawer: false,
			anchor_id: '',
			anchor_info: {},
			showTalentDataTab: true,
			isShowGoods: false,
			activeTab: '1',
			is_contact: true,
		};
	},
	computed: {
		...mapState(['vuex_baseInfo']),
		source() {
			const path = this.$route.path;
			const sourceMap = new Map([
				[CLUE_SEAS.path, CLUE_SEAS.source],
				[EMPHASIS_TALENT.path, EMPHASIS_TALENT.source],
				[MY_TALENT.path, MY_TALENT.source],
				[GROUP_SEAS.path, GROUP_SEAS.source],
			]);
			return sourceMap.get(path);
		},
		hostUrl() {
			return '//' + this.vuex_baseInfo.domain;
		},
		showStatus() {
			return (...status) => status.includes(this.partnerInfo.cooperate_status);
		},
		recommendType() {
			return this.anchor_info.recommend_type || [];
		},
		tagName() {
			let tag_arr = this.anchor_info.tag_arr || [];
			return tag_arr.map(item => item.tag_name).join(',');
		},
		isClaim() {
			return !!this.anchor_info.team_cooperate;
		},
		isShowTips() {
			const {
				anchor_info: { is_effective },
			} = this;
			return is_effective && !['0', '2'].includes(is_effective) ? true : false;
		},
		warnTitle() {
			const {
				anchor_info: { is_effective },
			} = this;
			let desc = '';
			// todo lsb 是否有视频号的情况
			const temPF = {
				[dataMap.PLATFORM_DY.value]: `由于达人未入住精选联盟导致获取不到数据，您可补充达人主页链接来获取达人基础数据(头像+昵称+抖音号+简介+粉丝量)`,
				[dataMap.PLATFORM_KS.value]: '达人基础数据获取失败，您可补充/修改达人主页链接，系统会根据链接重新获取达人数据。',
			};
			const tip = temPF[this.anchor_info.platform_id] || '';
			if (!['0', '2'].includes(is_effective)) {
				desc = tip;
			}
			return desc;
		},
		warnTips() {
			const {
				anchor_info: { is_effective },
			} = this;
			return this.$isDy(this.anchor_info.platform_id) && !['0', '2'].includes(is_effective) ? '无法获取达人信息' : '前往补充';
		},
		partners() {
			const { partners = [] } = this.anchor_info;
			return partners;
		},
		partnerInfo() {
			const { partners } = this;
			return partners[0] || {};
		},
		isLoginPartner() {
			const { user_id = '', partners = [] } = this.anchor_info;
			return partners.some(item => item.user_id == user_id);
		},
		isShowInfo() {
			if (this.isClueSeas) {
				return this.anchor_info.team_cooperate;
			} else {
				return true;
			}
		},
		/**
		 * Description 如果是找达人页面，优先判断是否认领，然后在判断是否有联系信息
		 * @returns {any}
		 */
		showIntroduction() {
			if (this.isClueSeas) {
				return this.anchor_info.have_contact;
			} else {
				return this.checkTalentCRMPermission.auth || this.anchor_info.have_contact;
			}
		},
		anchorDesc() {
			const { is_contact, anchor_info } = this;
			return is_contact ? anchor_info.anchor_desc || '-' : '认领后可查看简介详情与达人建联';
		},

		// },
	},
	methods: {
		async show(anchor_id, is_contact = true) {
			this.is_contact = is_contact;
			this.anchor_id = anchor_id;
			await this.getAnchorDetail();
			if (!this.$isSp(this.anchor_info.platform_id)) this.getLiveProductList();
			this.drawer = true;
		},
		handleClose() {
			this.activeTab = '1';
			this.anchor_id = '';
			this.drawer = false;
			this.isShowGoods = false;
			this.showTalentDataTab = true;
			this.$refs.talentDataTab?.reset();
			this.$isDy(this.anchor_info.platform_id) && this.$refs?.goodsDataTab?.reset();
			this.$refs.cooperationDataTab.reset();
			this.$refs.contactDataTab.reset();
		},
		handlerTab(index) {
			this.activeTab = index;
		},
		async getAnchorDetail() {
			return new Promise(async (rs, rj) => {
				try {
					const { anchor_id } = this;
					const { code, data: { anchor_info } = {} } = await getAnchorDetail({ anchor_id, dataView: 1 });
					if (code !== 0) return rj();
					this.anchor_info = anchor_info;
					this.$nextTick(() => {
						let timer = setTimeout(() => {
							this.getTabData();
							clearTimeout(timer);
						}, 0);
					});
					rs();
				} catch (error) {
					rj();
				}
			});
		},
		goToGoodsPage() {
			this.$router.push('/shopManage/shopLibrary/list');
		},
		async activateTalent() {
			const confirm = await this.$confirm('是否确认恢复？恢复后达人将恢复到原来的合作状态', '提示').catch(err => err);
			if (confirm !== 'confirm') return;
			const { anchor_id } = this;
			const { code } = await effectTalent({ anchor_id });
			if (code !== 0) return;
			this.$message.success('恢复成功');
			this.getList();
		},
		setTalentFocus: throttle(async function () {
			let { p_id: id, focus } = this.anchor_info;
			focus = focus == 1 ? 2 : 1;
			const { code } = await setTalentFocus({ id, focus });
			if (code !== 0) return;
			this.$message.success(`${focus == 1 ? '取消' : '重点'}关注成功`);
			this.getList();
		}, 1000),
		showInvalidDialog() {
			const { anchor_id } = this;
			this.$refs.invalidDialog.show(anchor_id);
		},
		showBuildContactDialog() {
			const { anchor_id, anchor_info } = this;
			this.$refs.buildContactDialog.show({ anchor_id, ...anchor_info });
		},
		getList() {
			this.handleClose();
			this.$emit('getList');
		},
		async getLiveProductList() {
			let pageInfo = {
				page_index: 1,
				page_size: 20,
			};
			const {
				anchor_info: { anchor_uid },
			} = this;
			if (!anchor_uid) return;
			const { code, data: { page: { item_total = 0 } = {} } = {} } = await getLiveProductList({ anchor_uid, live_id: 0, ...pageInfo });
			if (code !== 0) return;
			this.isShowGoods = +item_total != 0;
			this.$nextTick(() => this.$refs?.goodsDataTab?.getInfo());
		},
		modifyFun() {
			const { anchor_info, anchor_id } = this;
			const { is_effective } = anchor_info;
			if (!['0', '2'].includes(is_effective)) {
				const temPF = {
					[dataMap.PLATFORM_DY.value]: this.$refs.addDyHomeUrl.show,
					[dataMap.PLATFORM_KS.value]: this.$refs.addKsHomeUrl.show,
				};
				temPF[anchor_info.platform_id]({ ...anchor_info, anchor_id });
			}
		},
		getInfo() {
			this.$emit('getList');
			this.getTabData();
		},
		getTabData() {
			this.$refs?.talentDataTab?.getInfo();
			this.$refs?.cooperationDataTab?.getInfo();
			this.$refs?.contactDataTab?.getInfo();
		},
		showLinkmanDialog() {
			const { anchor_id, anchor_info } = this;
			this.$refs.linkmanDialog.show(
				{
					anchor_id,
					operate_time: Date.now(),
					is_pass: 1,
					contact_type: 1,
				},
				anchor_info,
			);
		},
		refresh() {
			this.handleClose();
			this.$emit('getList');
		},
		showFollowDialog() {
			this.$refs.followDialog.show(this.partners);
		},
		handleGoDy() {
			window.open(this.anchor_info.jx_main_url, '_blank');
		},
		handleGoKs() {
			window.open(
				`https://cps.kwaixiaodian.com/pc/leader/zone-cps/talent_detail?promoterId=${this.anchor_info.anchor_uid}&type=1&detailSource=CPS_BIZ_MERCHANT_MAIN_LIST`,
				'_blank',
			);
		},
		syncAnchorBase: throttle(async function () {
			const { anchor_id } = this;
			const temPF = {
				[dataMap.PLATFORM_DY.value]: syncAnchorBase,
				[dataMap.PLATFORM_KS.value]: syncAnchorBase,
				[dataMap.PLATFORM_SP.value]: syncSphAnchorBase,
			};
			const parmas = {
				[dataMap.PLATFORM_DY.value]: { anchor_id },
				[dataMap.PLATFORM_KS.value]: { anchor_id },
				[dataMap.PLATFORM_SP.value]: { anchorId: anchor_id },
			};
			const { code } = await temPF[this.anchor_info.platform_id](parmas[this.anchor_info.platform_id]);
			if (code !== 0) return;
			this.$message.success('更新成功');
			this.getAnchorDetail();
			this.getInfo();
		}, 1000),
		handleSpVerify() {
			this.getAnchorDetail();
		},
	},
};
</script>

<style lang="less">
.popover-qr {
	padding: 12px;

	.el-image {
		width: 150px;
		height: 150px;
	}

	.text {
		margin-top: 12px;
		font-size: 12px;
		color: #666;
		text-align: center;
		width: 150px;
	}
}
</style>
<style lang="less" scoped>
.detail-drawer {
	background: #fff;
	height: 100%;
	overflow: hidden;

	&.business {
		padding-bottom: 61px;
	}

	.detail-drawer-wrap {
		height: 100%;
		position: relative;
		overflow-y: auto;
	}

	.top {
		padding: 24px;
		display: flex;

		.left {
			margin-right: 8px;
		}

		.right {
			flex: 1;
			overflow: hidden;

			.talent-info {
				width: 250px;
			}

			.line {
				margin-left: 24px;
				margin-right: 34px;
				border-right: 1px solid #eee;
			}

			.el-button {
				margin: 0;
				padding: 4px 8px;
			}

			.icon-31erweima {
				font-size: 14px;
			}

			.recommend-item {
				height: 18px;
				line-height: 18px;
				padding: 0 4px;
				border-radius: 2px;
				background-color: #f8f8f8;
				color: #666;

				& + .recommend-item {
					margin-left: 4px;
				}
			}

			.uid {
				line-height: 16px;
				border-right: 1px solid #ccc;
				padding-right: 8px;
				margin-right: 8px;
			}

			.fans {
				height: 18px;
				line-height: 18px;
				padding: 0 6px;
				border-radius: 2px;
				box-sizing: border-box;
				border: 1px solid #fdd2a1;
				color: #fa8f14;
				text-align: center;
				font-size: 12px;
				display: inline-block;
			}

			.auth {
				display: inline-block;
				padding: 0 4px;
				height: 18px;
				line-height: 18px;
				font-size: 12px;
				text-align: center;
				border-radius: 2px;
				background-color: #e9f1ff;
				color: @color-primary;

				&.ks {
					background-color: #fef3e7;
					color: #fa8f14;
				}
			}

			.info {
				height: 50px;
				background: #f8fafd;
				padding: 0 12px;
				border-radius: 4px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-top: 20px;
				font-size: 14px;
				color: #333;
				box-sizing: border-box;

				.handler {
					color: #fa8f14;
					cursor: pointer;
				}
			}
		}
	}

	.bg-line {
		width: 100%;
		height: 8px;
		background-color: #f5f5f5;
	}

	.bottom-btn {
		border-top: 1px solid #eee;
		text-align: right;
		padding: 14px 24px;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
	}
}

.tips {
	margin: 16px 24px 0px 24px;
	background: #fef3e7;
	border: 1px solid @color-warning;
	padding: 11px 16px;
}

.warning {
	color: @color-warning;
}

.expire {
	font-size: 12px;
	color: #fa8f14;

	::v-deep .icon-a-help-circle-obangzhu-xian {
		font-size: 12px;
		color: #fa8f14;
	}
}
.i-talentCRM-myTalentDetail-starCard-dy {
	border-radius: 107px;
	padding: 1px 0px 1px 4px;
	width: 72px;
	box-sizing: border-box;

	span {
		transform: scale(0.84);
		font-size: 12px;
		white-space: nowrap;
		width: 43px;
	}
}
</style>
